import { render, staticRenderFns } from "./CarrierStaff.vue?vue&type=template&id=f2e654ce&"
import script from "./CarrierStaff.vue?vue&type=script&lang=js&"
export * from "./CarrierStaff.vue?vue&type=script&lang=js&"
import style0 from "./CarrierStaff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports